import { CgiAuthenticationOption, CgiAuthenticationType, CgiProvider } from "../models/CGI/CGI";
import { FormikDropdownOption } from "../models/Formik";
import { TranslationKey } from "../translations";

export const getCgiProviderName = (provider: string): string => {
    switch (provider) {
        case CgiProvider.Freja:
            return 'Freja eID';
        case CgiProvider.BankId:
            return 'BankID';
        default:
            return '';
    }
};

export const getCgiProvider = (provider: string): CgiProvider => {
    switch (provider) {
        case "freja":
            return CgiProvider.Freja;
        case "bankid":
        default:
            return CgiProvider.BankId;
    }
};

export const getProviderFromCgiAuthenticationOption = (authenticationOption: CgiAuthenticationOption): CgiProvider => {
    switch (authenticationOption) {
        case CgiAuthenticationOption.BankIdSameDevice:
        case CgiAuthenticationOption.BankIdOtherDevice:
            return CgiProvider.BankId;
        case CgiAuthenticationOption.FrejaSameDevice:
        case CgiAuthenticationOption.FrejaOtherDevice:
        default:
            return CgiProvider.Freja;
    }
}

export const getAuthenticationTypeFromCgiAuthenticationOption = (authenticationOption: CgiAuthenticationOption): CgiAuthenticationType => {
    switch (authenticationOption) {
        case CgiAuthenticationOption.BankIdSameDevice:
        case CgiAuthenticationOption.FrejaSameDevice:
            return 'same-device';
        case CgiAuthenticationOption.BankIdOtherDevice:
        case CgiAuthenticationOption.FrejaOtherDevice:
        default:
            return 'other-device';
    }
}

export const getCgiDropdownOptions = (t: (key: TranslationKey) => string, keys: typeof TranslationKey): FormikDropdownOption[] => {
    return [
        {
          label: t(keys.cgiBankIdSameDevice),
          value: CgiAuthenticationOption.BankIdSameDevice,
        },
        {
          label: t(keys.cgiBankIdOtherDevice),
          value: CgiAuthenticationOption.BankIdOtherDevice,
        },
        {
          label: t(keys.cgiFrejaSameDevice),
          value: CgiAuthenticationOption.FrejaSameDevice,
        },
        {
          label: t(keys.cgiFrejaOtherDevice),
          value: CgiAuthenticationOption.FrejaOtherDevice,
        },
      ];
}